import { Chapter, FadeUp, MaskedLines } from "@/components/motion";

const GONE = [
  "Buscar profesionales",
  "Contactar técnicos",
  "Explicar el problema una y otra vez",
  "Coordinar visitas",
  "Perseguir respuestas",
];

export default function Intro() {
  return (
    <section className="relative py-32 lg:py-44 bg-abyss border-y border-silver/10" data-testid="section-aprea">
      <div className="mx-auto max-w-[1500px] px-6 lg:px-12">
        <Chapter num="02" label="LA RESPUESTA" className="mb-12" />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-7">
            <h2 className="font-display font-800 uppercase leading-[0.98] tracking-tight text-4xl sm:text-6xl lg:text-7xl text-offwhite">
              <MaskedLines
                mode="view"
                lines={[
                  <span key="a">Tú sigues con tu negocio.</span>,
                  <span key="b">
                    Aprea <span className="font-cormorant normal-case font-medium text-metal">gestiona</span> la incidencia.
                  </span>,
                ]}
              />
            </h2>
            <FadeUp delay={0.2} className="mt-10 max-w-xl text-mist leading-relaxed">
              Aprea Gestora actúa como intermediario de gestión entre tu comercio y el profesional especializado.
              Recibimos la incidencia, la analizamos y activamos la gestión correspondiente. Sin llamadas en
              cadena, sin búsquedas, sin incertidumbre.
            </FadeUp>
          </div>
          <div className="lg:col-span-5">
            <FadeUp delay={0.1}>
              <span className="font-mono text-[10px] tracking-[0.35em] text-steel block mb-6">
                LO QUE DEJAS DE HACER
              </span>
              <div className="space-y-4">
                {GONE.map((item, i) => (
                  <FadeUp key={item} delay={0.1 + i * 0.07} y={16}>
                    <div className="flex items-center gap-4 text-mist group">
                      <span className="h-px w-6 bg-glow/60 group-hover:w-10 transition-[width] duration-300" />
                      <span className="text-sm md:text-base line-through decoration-steel/60 decoration-1 group-hover:text-silver transition-colors duration-300">
                        {item}
                      </span>
                    </div>
                  </FadeUp>
                ))}
              </div>
            </FadeUp>
          </div>
        </div>

        <FadeUp delay={0.15} className="mt-28 lg:mt-36">
          <p className="font-oswald font-600 uppercase text-center leading-[1.05] tracking-tight text-[9vw] lg:text-8xl">
            <span className="text-offwhite">Tú detectas.</span>{" "}
            <span className="text-metal">Nosotros gestionamos.</span>
          </p>
        </FadeUp>
      </div>
    </section>
  );
}
